import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
  inject,
} from '@angular/core';
import { BOProduct, UnitPrice } from '@boels/models';

import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { PriceService } from './price.service';
import { Subscription } from 'rxjs';
import { UserTypeService } from '@boels/helpers';

@Component({
  imports: [TranslocoModule],
  selector: 'boels-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productGrid', 'productDetails'],
    },
  ],
})
export class ProductPriceComponent implements OnInit, OnDestroy {
  private priceService = inject(PriceService);
  private cd = inject(ChangeDetectorRef);

  @Input() product: BOProduct;
  #userTypeService = inject(UserTypeService);
  unitPrice: UnitPrice | undefined;
  label: string;

  subs$ = new Subscription();

  setProductPriceData() {
    const unitPrices = this.priceService.getPricesForUserType(this.product);
    this.unitPrice = unitPrices ? unitPrices[0] : undefined;
    this.label = this.priceService.getVatLabel(true);
    this.cd.markForCheck();
  }

  ngOnInit(): void {
    this.setProductPriceData();
    this.subs$.add(
      this.#userTypeService.onUserTypeChange().subscribe(() => {
        this.setProductPriceData();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
